// Module
var code = "<h2 id=\"paying-more-each-month\">Paying More Each Month?</h2> <p>Target your payments however you want.</p> ";
// Exports
export default code;